import { Col, Grid, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import LoginForm from "../components/onboarding/LoginForm";

const { Title } = Typography;

export default function Login() {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.lg;
    return (
        <div style={{ paddingTop: 24, paddingBottom: 24, paddingLeft: isMobile ? 24 : 0, paddingRight: isMobile ? 24 : 0 }}>
            <Row>
                <Col
                    xxl={{ span: 14, offset: 3 }}
                    xl={{ span: 14, offset: 3 }}
                    lg={{ span: 15, offset: 2 }}
                    md={{ span: 20, offset: 2 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                >
                    <Title
                        level={2}
                        style={{ textAlign: isMobile ? "center" : "start" }}
                    >
                        Login
                    </Title>
                </Col>
            </Row>
            <Row>
                <Col
                    xxl={{ span: 14, offset: 3 }}
                    xl={{ span: 14, offset: 3 }}
                    lg={{ span: 15, offset: 2 }}
                    md={{ span: 20, offset: 2 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                >
                    <LoginForm />
                </Col>
            </Row>
            <Row style={{ marginTop: 16 }}>
                <Col
                    xxl={{ span: 14, offset: 3 }}
                    xl={{ span: 14, offset: 3 }}
                    lg={{ span: 15, offset: 2 }}
                    md={{ span: 20, offset: 2 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                >
                    <span>Need an account?&nbsp;</span>
                    <Link to={"/join"}>
                        <span>Register</span>
                    </Link>
                    <span>&nbsp;·&nbsp;</span>
                    <Link to={"/forgot-password"}>
                        <span>Forgot password?</span>
                    </Link>
                </Col>
            </Row>
        </div>
    );
}
